import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const OwnVehSparesReport = () => {
  useAuthRedirect();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const branch = localStorage.getItem("branch");
  const startYear = 2007;
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchData();
  }, [selectedYear, selectedMonth]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://rfs2.infraconsoft.net.in/api/get_own_veh_spare_rep_api",
        {
          params: {
            month: selectedMonth,
            year: selectedYear,
            branch: branch,
            id: id,
          },
        }
      );
      // console.log("API Response:", response.data.sparesReport);
      setData(response.data.sparesReport);
      setFilteredData(response.data.sparesReport);
    } catch (error) {
      console.error("Error fetching sparesReport:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((item) =>
      (String(item.stn_purnumber || "").toLowerCase().includes(term) ||
       String(item.stn_dpt || "").toLowerCase().includes(term))
    );

    setFilteredData(filtered);
  };

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const exportToExcel = () => {
    // Collect the data you want to export from the table
    const exportData = currentData.map((item, index) => {
      let cumulative = item.cboMachine || 0; // Initialize cumulative variable for each row

      let totalvalue = 0;
      if (item.fld_fifo && item.Quantities) {
        const quantityArray = item.Quantities.split(",");
        const costArray = item.fld_fifo.split(",");
        for (let i = 0; i < costArray.length; i++) {
          totalvalue += (parseInt(quantityArray[i]) || 0) * (parseInt(costArray[i]) || 0);
        }
      }

      return {
        SNo: indexOfFirstItem + index + 1, // S.No calculation based on pagination
        Date: new Date(item.fld_vdate).toLocaleDateString(),
        StartingHours: item.fld_sthrs,
        ClosingHours: item.fld_endhrs,
        WorkingHours: item.fld_wohrs,
        CumulativeHours: cumulative,
        StartingKM: item.fld_stkm,
        ClosingKM: item.fld_endkm,
        WorkingKM: item.fld_wokm,
        CumulativeKM: (item.fld_wokm || 0), // Example for cumulative KM calculation
        NumberOfLoads: item.fld_noload,
        Location: item.fld_location,
        Remarks: item.fld_remarks
      };
    });

    // Create a worksheet from the export data
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Create a new workbook and append the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Vehicle Details");

    // Write the workbook to a binary array
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Create a Blob from the Excel buffer and download it
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    // Save the file with a dynamic name based on the selected month and year
    saveAs(blob, `vehicle_details_${selectedMonth}-${selectedYear}.xlsx`);
  };

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
           <div className="back-div">
                                        <h2 className="add-txt">Spares Issued Report - Own Vehicle</h2>
                                        <Link to={`/vehicle_spares_report`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
                                        </div>
          <Time />
        </section>

        {/* <div className="add-new-container">
          <button className="add-new-btn" onClick={exportToExcel}>
            <i className="fa-solid fa-file-excel"></i> Export to Excel
          </button>
        </div> */}

        {/* Month & Year Selection */}
        <div className="month-year-container">
          <p className="title">Select your Month & Year:</p>

          <div className="select-container">
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(12).keys()].map((i) => (
                <option key={i + 1} value={i + 1}>
                  {(i + 1).toString().padStart(2, "0")}
                </option>
              ))}
            </select>

            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(currentYear - startYear + 1).keys()].map((i) => (
                <option key={startYear + i} value={startYear + i}>
                  {startYear + i}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Code</th>
                <th>Vehicle Status</th>
                <th>Date</th>
                <th>Material Code</th>
                <th>Material Name</th>
                <th>UOM</th>
                <th>Material Qty</th>
                <th>Total Amount</th>
                <th>Cumulative</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => {
                  let cumulative = item.cboMachine || 0;

                  let totalvalue = 0;
                  if (item.sfIssuesDetail_price && item.sfissuesDetail_issuedQuantity) {
                    const quantityArray = item.sfissuesDetail_issuedQuantity.split(",");
                    const costArray = item.sfIssuesDetail_price.split(",");
                    for (let i = 0; i < costArray.length; i++) {
                      totalvalue += (parseInt(quantityArray[i]) || 0) * (parseInt(costArray[i]) || 0);
                    }
                  }

                  return (
                    <tr key={index}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{item.cbovehicle}</td>
                      <td>Own</td>
                      <td>{new Date(item.logoutTime).toLocaleDateString()}</td>
                      <td>{item.sfissuesDetail_itemCode}</td>
                      <td>{item.itemmaster_name}</td>
                      <td>{item.itemmaster_uom}</td>
                      <td>{item.sfissuesDetail_issuedQuantity}</td>
                      <td>{totalvalue.toFixed(2)}</td>
                      <td>{cumulative}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default OwnVehSparesReport;
